<template>
  <div class="shandong-h5-world">
    <Resource
      :src="getFeUrl('/youyan-platform/png/shandong/h5-bg-7.png')"
      :transform-resource="transformImage"
      class="w-full"
      style="object-fit: inherit !important"
    />
    <div class="bottom" @click="open">
      点击报名
      <img loading="lazy" :src="arrowRight" class="h-[17px] ml-[8px]" alt="" />
    </div>
    <OrderModal
      ref="modalRef"
      class="mobile-ppt"
      :width="408"
      :height="559"
      centered
      title="请前往电脑端报名参与活动"
    >
      <template #content>
        <div class="order-content">
          <div class="z-10 relative">
            <div
              class="mt-[23px] relative text-[18px] font-bold flex flex-col items-center bg-back-1 rounded-[22px] py-[4vw] px-[10vw]"
            >
              <div class="text-bg">
                <div class="z-10 relative text-[20px]">扫描添加活动小助手</div>
                <div class="line-bg"></div>
              </div>
              <div class="text-[16px] leading-[30px]">参与报名活动</div>
              <div class="mt-[17px]">
                <Resource
                  :src="qrcodeUrl"
                  class="w-full"
                  :transform-resource="transformImage"
                ></Resource>
              </div>
            </div>
            <div class="line"></div>
            <div class="copy-wrap">
              <div class="copy" @click="onCopy">或复制链接至电脑</div>
            </div>
          </div>
        </div>
      </template>
    </OrderModal>
  </div>
</template>

<script lang="ts" setup>
import OrderModal from './components/modal.vue'
import { copyToClipboard } from '~/utils'

defineProps<{
  qrcodeUrl?: string
}>()

const { $t } = useNuxtApp()

const arrowRight = transformImage(
  getFeUrl('/youyan-platform/png/ppt/h5-right.png')
)

const modalRef = ref()

const open = () => {
  modalRef.value.toggle?.()
}

const onCopy = () => {
  copyToClipboard(window.location.href).then(() => {
    message.success($t('fu-zhi-cheng-gong'))
  })
}

const giftBg = useCssBgUrl(
  '/youyan-platform/png/ppt/icon-prize-gift.png?x-oss-process=image/format,webp'
)

const titleBg = useCssBgUrl(
  '/youyan-platform/png/ppt/gift-title.png?x-oss-process=image/format,webp'
)
</script>
<style lang="scss">
.mobile-ppt {
  .title {
    font-size: 20px;
  }
  .ant-modal-close {
    top: 24px !important;
  }
}
</style>
<style lang="scss" scoped>
.shandong-h5-world {
  @apply h-screen relative bg-[#FEFFFF];
  .host-shadow {
    background: linear-gradient(
      180deg,
      rgba(249, 244, 255, 0.95) 0%,
      #ffffff 100%
    );
    box-shadow: 0px 5px 32px 0px rgba(13, 3, 212, 0.08);
    border-radius: 4.2vw;
    margin-top: 7vw;
  }
  .bottom {
    @apply fixed bottom-[30px] left-[44px] right-[44px] flex justify-center items-center;
    height: 44px;
    font-weight: bold;
    font-size: 18px;
    color: #ffffff;
    letter-spacing: 2px;
    // background: var(--purple-6);
    background: linear-gradient(180deg, #f96666 0%, #e9603b 37%, #cb4825 100%);
    // box-shadow: 0px 12px 20px -8px rgba(105, 98, 255, 0.49);
    border-radius: 24px;
    // border: 1px solid var(--purple-6);
  }
  .content {
    @apply w-full mx-auto pb-[190px] bg-[#FEFFFF];
    .owner {
      @apply relative -top-[15vw] px-[3vw];
    }
    .prize {
      @apply p-[3vw] rounded-[5vw] relative mx-[3vw];
      background: #b2b6fe;
      border: 1px solid #b2b6fe;
      .gift {
        @apply h-[93px] w-[101px] absolute left-[-10px] -top-[40px];
        background: v-bind('giftBg') no-repeat;
        background-position: center center;
        background-size: contain;
      }
      .title {
        @apply w-[55vw] mx-auto h-[26vw] absolute -top-[27px] left-0 right-0;
        background: v-bind('titleBg') no-repeat;
        background-position: center center;
        background-size: contain;
      }
      .prize-info {
        @apply relative;
        .prize-icon {
          @apply absolute right-[-11vw] w-[20vw] top-[20vw];
        }
      }
    }
  }
}

.order-content {
  @apply rounded-[20px] relative;
  z-index: 10;
  box-shadow: 0px 2px 12px 0px rgba(222, 222, 255, 0.4);
  .copy-wrap {
    @apply bg-[#fff] rounded-[22px] py-[8vw] px-[10vw];
  }
  .copy {
    @apply flex-y-center p-[13px_23px];
    // background: var(--purple-6);
    background: #ff7062;
    box-shadow: 0px 3px 10px -4px rgba(255, 142, 0, 0.4859);
    border-radius: 16px;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    justify-content: center;
    // border: 1px solid var(--purple-6);
  }
  .line {
    @apply relative mx-[3vw];
    width: 92%;
    height: 1px;
    background-image: linear-gradient(
      to right,
      #ffd2af 0%,
      #ffd2af 50%,
      transparent 50%
    );
    background-size: 10px 1px;
    background-repeat: repeat-x;
  }
  .text-bg {
    @apply relative;
    .line-bg {
      z-index: 1;
      position: absolute;
      bottom: 0;
      left: 0;
      height: 10px;
      width: 100%;
      background: linear-gradient(180deg, #ffdbc8 0%, #fff8e6 100%);
    }
  }
}
</style>
